import React from 'react';
import classnames from 'classnames';

import InitiativeWizardFooter from './initiativeWizardFooter';
import InitiativeWizardHeader from './initiativeWizardHeader';

import styles from '../styles/initiativeWizard.module.scss';

const InitiativeWizard = ({
  currentIndex,
  isSubmitting,
  onNavigateButtonClick,
  onSubmitButtonClick,
  pages,
}) => (
  <>
    <InitiativeWizardHeader
      currentIndex={currentIndex}
      onNavigateButtonClick={onNavigateButtonClick}
      pages={pages}
    />
    {pages.map(({ body, title }, index) => (
      <div
        className={classnames(styles.body, index === currentIndex && styles.isActive)}
        key={title}
      >
        {body}
      </div>
    ))}
    <InitiativeWizardFooter
      canNavigate
      canSubmit={pages.every(({ isComplete }) => isComplete !== false)}
      currentIndex={currentIndex}
      isSubmitting={isSubmitting}
      nextPage={pages[currentIndex + 1]}
      onNavigateButtonClick={onNavigateButtonClick}
      onSubmitButtonClick={onSubmitButtonClick}
      previousPage={pages[currentIndex - 1]}
    />
  </>
);

export default React.memo(InitiativeWizard);
